import { Box, Link } from '@hover/blueprint';
import React from 'react';

import { Button } from 'src/shared/components';
import { useTranslate } from 'src/shared/hooks';
import { TranslationNamespace } from 'src/shared/hooks/useTranslate';
import { Route } from 'src/shared/route';

export const LOGIN_BUTTON_TEST_ID = 'header-login';

const LoginButton = () => {
  const commonT = useTranslate(TranslationNamespace.COMMON);
  return (
    <Box>
      <Link
        aria-label="login"
        href={Route.LOGIN.path}
        isMinimal
        marginRight={200}
        testId={LOGIN_BUTTON_TEST_ID}
      >
        <Button>{commonT('logIn')}</Button>
      </Link>
    </Box>
  );
};

export { LoginButton };
